import { render, staticRenderFns } from "./unpublished-table.vue?vue&type=template&id=6cf7e869"
import script from "./unpublished-table.vue?vue&type=script&lang=js"
export * from "./unpublished-table.vue?vue&type=script&lang=js"
import style0 from "./unpublished-table.vue?vue&type=style&index=0&id=6cf7e869&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports